// @ts-nocheck
import React from "react";
import ThirdPartyIntegrationController, {
  Props,
} from "./ThirdPartyIntegrationController.web";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import StorageProvider from "../../../../framework/src/StorageProvider.web";
import { withRouter } from "react-router-dom";
import withDialog from "../../../../components/src/withDialog.web";
import {
  Typography,
  Button,
  Grid,
  withStyles,
  createStyles,
  Icon,
} from "@material-ui/core";
import {
  cpaChargeIntegrations,
  googleDriveIntegrations,
  calendlyIntegrations,
  zapierIntegrations,
} from "../assets";
import CalendlyIntegration from "./calendlyIntegration.web";
import CancelIcon from "@material-ui/icons/Cancel";
import DoneIcon from "@material-ui/icons/CheckCircle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CustomGrid from "../../../../components/src/CustomGrid.web";
import withPermissions from "../../../../components/src/withPermissions.web";
import ConfirmDialog from "./ConfirmDialog.web";
import { GoogleLogin } from "react-google-login";
import { cpaChargeClientId } from "../../../../framework/src/config";

// Se uma segunda integracao precisar do mesmo aviso, isto sobe para
// packages/components/src/ConnectionAlert.web.tsx sem alteracao.
export const ConnectionAlert = ({ classes, message }) => (
  <Grid container wrap="nowrap" className={classes.connectionAlert}>
    <ErrorOutlineIcon className={classes.connectionAlertIcon} />
    <Typography className={classes.connectionAlertText}>
      <strong>Reconnect required</strong>
      <br />
      {message}
    </Typography>
  </Grid>
);

export class ThirdPartyIntegration extends ThirdPartyIntegrationController {
  constructor(props: Props) {
    super(props);
  }

  async componentDidMount() {
    const token = await StorageProvider.get("authToken");
    const accountId = await StorageProvider.get("accountId");
    const role = await StorageProvider.get("role");
    const params = new URLSearchParams(this.props.location.search);
    const code = params.get("code");
    this.setState(
      {
        token: token,
        accountId: accountId,
        role: role,
      },
      () => {
        if (code) {
          this.getAccessTokenOfCPACharge(code);
          this.props.history.replace(this.props.location.pathname);
        }
        this.getCFSSettingFortpi();
        this.getCPADetialbyAccountId();
        this.getGoogle();
        this.getApiKeys();
      }
    );
  }

  checkIfClientSecrentPresent = (url) => {
    window.location.href = `https://secure.cpacharge.com/oauth/authorize?redirect_uri=${
      url
    }/home/settings/integrations&client_id=${cpaChargeClientId}&scope=payments&response_type=code`;
  };

  reconnectToCPACharge = () => {
    if (this.state.reconnecting) {
      return;
    }
    this.setState({ reconnecting: true }, () => {
      this.checkIfClientSecrentPresent(window.location.origin);
    });
  };

  openCaliendlylDialog = () => {
    window.open("https://calendly.com/event_types/user/me", "_target",'noopener');
    this.props
      .openDialogBox({
        dataToPass: {
          meetingLink: this.state.meeting_link,
        },
        width: "60%",
        renderedComponent: CalendlyIntegration,
        withCustomDialog: false,
      })
      .then((data) => {
        this.updateCFSSetting({ meetingLink: data.meetingLink }, false);
      });
  };
  responseGoogleSuccess = async (data) => {
    const profileData = data?.profileObj;
    if (profileData?.email && profileData?.googleId) {
      this.connectToGoogle(data);
    }
  };
  responseGoogleFailure = (data) => {};

  confirmRevokeApiKey = (apiKey) => {
    this.props
      .openDialogBox({
        dataToPass: {
          message: `Revoke "${apiKey.name}"? Any Zap using this key stops working immediately.`,
          confirmLabel: "Revoke",
        },
        width: "35%",
        renderedComponent: ConfirmDialog,
        withCustomDialog: false,
      })
      .then((confirmed) => {
        if (confirmed) {
          this.revokeApiKey(apiKey.id);
        }
      });
  };

  formatApiKeyDate = (value) =>
    value ? new Date(value).toLocaleDateString() : "Never";

  render(): React.ReactNode {
    const { classes, permissions } = this.props;
    const currentTime = Math.floor(Date.now() / 1000);
    const expirationTime = this.state.googleObj?.tokenObj?.expires_at / 1000;
    const isFirmOwner = this.state.role !== "Firm Employee User";
    return (
      <Grid justifyContent="center" container>
        <Grid item xs={12}>
          <Typography className={classes.pageHeading} color="primary">
            Integrations
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            justifyContent="space-between"
            className={[classes.gridSpacing, classes.whiteCard]}
          >
            <Grid item xs={12}>
              <Typography className={classes.heading} color="textPrimary">
                Available Integrations
              </Typography>
            </Grid>
            <CustomGrid
              item
              xs={3}
              width="31%"
              container
              direction="column"
              justifyContent="space-between"
              alignItems="center"
              className={classes.packageCard}
            >
              {this.state.payment_access_token ? (
                <Icon className={classes.icon}>
                  <DoneIcon color="primary" />
                </Icon>
              ) : (
                <Icon className={classes.icon}>
                  <CancelIcon color="error" />
                </Icon>
              )}
              <Grid
                item
                container
                alignItems="flex-start"
                justifyContent="center"
                style={{
                  minHeight: "150px",
                }}
              >
                <img style={{ width: "160px" }} src={cpaChargeIntegrations} />
              </Grid>
              <Typography className={classes.integrationNames}>
                CPA Charge
              </Typography>
              <Typography className={classes.integrationDescription}>
                Automatically collect payments and manage monthly billing
                through SmartPath.
              </Typography>
              {this.state.payment_access_token &&
                this.state.cpa_connection_status === "invalid" && (
                  <ConnectionAlert
                    classes={classes}
                    message="This connection is no longer valid. Payments will fail until you reconnect."
                  />
                )}
              {this.state.payment_access_token &&
              this.state.cpa_connection_status === "invalid" ? (
                <React.Fragment>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.reconnectToCPACharge}
                    className={classes.connectDisconnectButton}
                    disabled={
                      this.state.reconnecting ||
                      !permissions.includes("Make payment (CPA Charge)-Payments")
                    }
                  >
                    {this.state.reconnecting ? "Redirecting..." : "Reconnect"}
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => this.disconnectFromCPACharge()}
                    className={classes.secondaryActionButton}
                    disabled={
                      this.state.reconnecting ||
                      !permissions.includes("Make payment (CPA Charge)-Payments")
                    }
                  >
                    Disconnect
                  </Button>
                </React.Fragment>
              ) : (
                <Button
                  variant="contained"
                  color={
                    this.state.payment_access_token ? "secondary" : "primary"
                  }
                  onClick={() => {
                    if (this.state.payment_access_token) {
                      this.disconnectFromCPACharge();
                    } else {
                      this.checkIfClientSecrentPresent(window.location.origin);
                    }
                  }}
                  className={classes.connectDisconnectButton}
                  disabled={
                    !permissions.includes("Make payment (CPA Charge)-Payments")
                  }
                >
                  {this.state.payment_access_token ? "Disconnect" : "Connect"}
                </Button>
              )}
              <Typography className={classes.createAccountText}>
                Don't have an account? Create one{" "}
                <a
                  href="https://www.cpacharge.com/partners/smartpath/"
                  target="_blank"
                  rel="noopener"
                >
                  here
                </a>
              </Typography>
            </CustomGrid>
            <CustomGrid
              item
              width="31%"
              container
              direction="column"
              justifyContent="space-between"
              alignItems="center"
              className={classes.packageCard}
            >
              {this.state.meeting_link ? (
                <Icon className={classes.icon}>
                  <DoneIcon color="primary" />
                </Icon>
              ) : (
                <Icon className={classes.icon}>
                  <CancelIcon color="error" />
                </Icon>
              )}
              <Grid
                item
                container
                alignItems="flex-start"
                justifyContent="center"
                style={{
                  minHeight: "150px",
                }}
              >
                <img style={{ width: "110px" }} src={calendlyIntegrations} />
              </Grid>
              <Typography className={classes.integrationNames}>
                Calendly
              </Typography>
              <Typography className={classes.integrationDescription}>
                Allow clients to book a roadmap review meeting directly from
                your Conversion Survey
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  this.openCaliendlylDialog();
                }}
                className={classes.connectDisconnectButton}
              >
                {this.state.meeting_link ? "Connected" : "Connect"}
              </Button>
            </CustomGrid>
            <CustomGrid
              item
              width="31%"
              container
              direction="column"
              justifyContent="space-between"
              alignItems="center"
              className={classes.packageCard}
            >
              {this.state.googleObj ? (
                <Icon className={classes.icon}>
                  <DoneIcon color="primary" />
                </Icon>
              ) : (
                <Icon className={classes.icon}>
                  <CancelIcon color="error" />
                </Icon>
              )}
              <Grid
                item
                container
                alignItems="flex-start"
                justifyContent="center"
                style={{
                  minHeight: "150px",
                }}
              >
                <img style={{ width: "110px" }} src={googleDriveIntegrations} />
              </Grid>
              <Typography className={classes.integrationNames}>
                G Suite
              </Typography>
              <Typography className={classes.integrationDescription}>
                Integrate your Firm's G Suite with SmarthPath
              </Typography>
              {!this.state.googleObj || expirationTime < currentTime ? (
                <GoogleLogin
                  clientId="870709959925-tstesujqeqfhstl71euckvhfor6e45f7.apps.googleusercontent.com"
                  render={(renderProps) => (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={renderProps.onClick}
                      className={classes.connectDisconnectButton}
                    >
                      Connect
                    </Button>
                  )}
                  buttonText="Login"
                  scope="https://www.googleapis.com/auth/drive"
                  onSuccess={this.responseGoogleSuccess}
                  onFailure={this.responseGoogleFailure}
                  cookiePolicy={"single_host_origin"}
                />
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.disconnectGoogle}
                  className={classes.connectDisconnectButton}
                >
                  Disconnect
                </Button>
              )}
            </CustomGrid>
            <CustomGrid
              item
              width="31%"
              container
              direction="column"
              justifyContent="space-between"
              alignItems="center"
              className={classes.packageCard}
            >
              {this.state.apiKeys.length > 0 ? (
                <Icon className={classes.icon}>
                  <DoneIcon color="primary" />
                </Icon>
              ) : (
                <Icon className={classes.icon}>
                  <CancelIcon color="error" />
                </Icon>
              )}
              <Grid
                item
                container
                alignItems="center"
                justifyContent="center"
                style={{
                  minHeight: "150px",
                }}
              >
                <img style={{ width: "160px" }} src={zapierIntegrations} />
              </Grid>
              <Typography className={classes.integrationNames}>
                Zapier
              </Typography>
              <Typography className={classes.integrationDescription}>
                Generate an API key to connect SmartPath to your Zaps and
                automate your workflows.
              </Typography>
              {this.state.apiKeys.length > 0 && (
                <Grid item className={classes.apiKeyList}>
                  {this.state.apiKeys.map((apiKey) => (
                    <Grid
                      key={apiKey.id}
                      container
                      wrap="nowrap"
                      alignItems="center"
                      justifyContent="space-between"
                      className={classes.apiKeyRow}
                    >
                      <Grid item>
                        <Typography className={classes.apiKeyName}>
                          {apiKey.name}
                        </Typography>
                        <Typography className={classes.apiKeyMeta}>
                          Created {this.formatApiKeyDate(apiKey.created_at)}
                          {" · "}
                          Last used: {this.formatApiKeyDate(apiKey.last_used_at)}
                        </Typography>
                      </Grid>
                      {isFirmOwner && (
                        <Button
                          size="small"
                          color="secondary"
                          onClick={() => this.confirmRevokeApiKey(apiKey)}
                          disabled={this.state.revokingApiKeyId === apiKey.id}
                        >
                          Revoke
                        </Button>
                      )}
                    </Grid>
                  ))}
                </Grid>
              )}
              {isFirmOwner ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.createApiKey}
                  className={classes.connectDisconnectButton}
                  disabled={this.state.generatingApiKey}
                >
                  {this.state.generatingApiKey
                    ? "Generating..."
                    : "Generate key"}
                </Button>
              ) : (
                <Typography className={classes.createAccountText}>
                  Only the firm account can generate an API key.
                </Typography>
              )}
            </CustomGrid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const ThirdPartyIntegrationWithRouter = withRouter(ThirdPartyIntegration);
const ThirdPartyIntegrationAlertBox = withAlertBox(
  ThirdPartyIntegrationWithRouter
);
const ThirdPartyIntegrationLoader = withLoader(ThirdPartyIntegrationAlertBox);
const ThirdPartyIntegrationToast = withToast(ThirdPartyIntegrationLoader);
const ThirdPartyIntegrationWithDialog = withDialog(ThirdPartyIntegrationToast);
const ThirdPartyIntegrationWithPermissions = withPermissions(
  ThirdPartyIntegrationWithDialog
);

export default withStyles((theme) =>
  createStyles({
    center: {
      textAlign: "center",
    },
    packageCard: {
      border: `1px solid ${theme.palette.secondary.main}`,
      borderRadius: "1rem",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.29)",
      padding: "1.5rem 3rem",
      marginTop: "1rem",
      position: "relative",
    },
    icon: {
      position: "absolute",
      top: "8px",
      right: "8px",
    },
    marginTop: {
      marginTop: "3rem",
    },
    gridSpacing: {
      margin: theme.spacing(2, 0),
      [theme.breakpoints.down("md")]: {
        margin: theme.spacing(1, 0),
      },
    },
    whiteCard: {
      padding: theme.spacing(4),
      borderRadius: theme.spacing(2),
      backgroundColor: "#ffffff",
      boxShadow: `0px 4px 18px rgba(0,0,0,0.1)`,
      [theme.breakpoints.down("md")]: {
        padding: theme.spacing(1.5),
      },
    },
    heading: {
      fontWeight: 600,
      fontSize: "1.3rem",
      color: theme.palette.secondary.main,
    },
    pageHeading: {
      fontSize: "1.5rem",
      fontFamily: "DM Sans",
    },
    crossButton: {
      cursor: "pointer",
    },
    integrationNames: {
      fontSize: "1.2rem",
      color: theme.palette.secondary.main,
      margin: "1rem 0",
      textAlign: "center",
    },
    integrationDescription: {
      fontSize: "1.2rem",
      fontWeight: 600,
      color: theme.palette.text.secondary,
      marginBottom: "1rem",
      textAlign: "center",
    },
    connectDisconnectButton: {
      marginTop: "auto",
      width: "75%",
    },
    secondaryActionButton: {
      marginTop: "0.5rem",
      width: "75%",
    },
    connectionAlert: {
      alignItems: "flex-start",
      backgroundColor: "#fdf3e0",
      border: "1px solid #f0dcb4",
      borderRadius: "6px",
      marginBottom: "1rem",
      padding: "0.75rem",
      textAlign: "left",
      width: "75%",
    },
    connectionAlertIcon: {
      color: "#c98a12",
      fontSize: "1.25rem",
      marginRight: "0.5rem",
    },
    connectionAlertText: {
      color: "#5c421a",
      fontSize: "0.95rem",
      lineHeight: 1.4,
    },
    createAccountText: {
      fontSize: "1rem",
      fontWeight: 600,
      color: theme.palette.text.secondary,
      marginTop: "1rem",
      textAlign: "center",
      "& > a": {
        color: theme.palette.secondary.main,
      },
    },
    driveImg: {
      width: "110px",
    },
    apiKeyList: {
      marginBottom: "1rem",
      width: "100%",
    },
    apiKeyRow: {
      borderTop: "1px solid #e0e0e0",
      padding: "0.5rem 0",
      textAlign: "left",
    },
    apiKeyName: {
      color: theme.palette.secondary.main,
      fontSize: "1rem",
      fontWeight: 600,
    },
    apiKeyMeta: {
      color: theme.palette.text.secondary,
      fontSize: "0.85rem",
    },
  })
)(ThirdPartyIntegrationWithPermissions);
